const PrintWeightOptions = [
  { value: 'no', label: 'No', view: 'all' },
  { value: 'yes', label: 'Yes', view: 'all' },
  { value: 'customer', label: 'Use Customer', view: 'project' },
];

export default PrintWeightOptions;
